import { PAN_ZOOM, SET_MAP_UPDATE_SOURCE } from './actions';


const DefaultState = {
  coords: [],
  zoom: undefined,
  updateSource: 'UI' // url / ui
};

const map = (state = DefaultState, action) => {



  switch (action.type) {
    case PAN_ZOOM:
      state.coords = action.data.coords;
      state.zoom = action.data.zoom;

      if(action.data.updateSource){
        state.updateSource = action.data.updateSource;
      } else {
        state.updateSource = 'UI';
      }

      return Object.assign({}, state);
    case SET_MAP_UPDATE_SOURCE:

      state.updateSource = action.updateSource;


      return Object.assign({}, state);
    default:
      return state;
  }
};

export {map};